import { Container } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import CustomHeader from '../../../components/General/CustomHeader';
import Page from '../../../components/Layout/Page';
import DevicesTableContent from '../../Devices/components/DevicesTableContent';
import useStyles from './styles';
import { ReduxState } from '../../../types';

const AccountDevicesListView = () => {
  const classes = useStyles();
  const { selectedAccount } = useSelector((state: ReduxState) => state.userAccount);
  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);

  return (
    <Page
      className={classes.root}
      title='Equipos'
    >
      <Container maxWidth={false}>
        <CustomHeader title='Equipos' showBackButton={false} />
        <DevicesTableContent
          selectedAccountId={selectedAccount?.id}
          selectedFarmId={selectedFarm?.id}
          adminView={false}
        />
      </Container>
    </Page>
  );
};

export default AccountDevicesListView;
